var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedulingBlockedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    fill: "#ED7047",
    stroke: "#ED7047"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8068 13.8285C15.1014 14.1317 15.0538 14.5819 14.7002 14.8343C14.5444 14.9456 14.3552 15 14.1672 15C13.9283 15 13.6914 14.9125 13.5268 14.7429L9.99973 11.0964L6.47382 14.7236C6.30904 14.8931 6.07228 14.9808 5.83348 14.9808C5.64549 14.9808 5.45641 14.9263 5.30043 14.8151C4.9468 14.5626 4.89914 14.1124 5.19382 13.8093L8.91503 9.98117L5.19319 6.1723C4.8986 5.86917 4.9462 5.41895 5.29991 5.1665C5.65302 4.91337 6.17826 4.95408 6.4733 5.25788L9.99973 8.88434L13.5256 5.25712C13.8199 4.954 14.3454 4.91292 14.699 5.16574C15.0527 5.41819 15.1003 5.86841 14.8056 6.17154L11.0844 9.99965L14.8068 13.8285Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedulingBlockedIcon);
export default __webpack_public_path__ + "static/media/scheduling-blocked-icon.f1461908b096dca34675427f1dd90cbb.svg";
export { ForwardRef as ReactComponent };